<h2 mat-dialog-title>
  {{ (isEdit ? 'waters.testimonials.edit-title' : 'waters.testimonials.add-title') | translate }}
</h2>
<mat-dialog-content>
  <form [formGroup]="form" class="flex flex-col gap-4 pt-2">
    <mat-form-field>
      <mat-label>{{ 'waters.testimonials.field.site' | translate }}</mat-label>
      <mat-select formControlName="siteId">
        <mat-option [value]="null">{{ 'generic.none' | translate }}</mat-option>
        @for (site of codeListsService.sites(); track site.id) {
          <mat-option [value]="site.id">{{ site.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'waters.testimonials.field.title' | translate }}</mat-label>
      <input matInput formControlName="title" maxlength="100" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'waters.testimonials.field.testimonial' | translate }}</mat-label>
      <textarea matInput formControlName="testimonial" rows="5"></textarea>
    </mat-form-field>

    <div class="flex flex-col gap-1">
      <label class="text-sm text-gray-600">
        {{ 'waters.testimonials.field.score' | translate }}: {{ form.controls.score.value }} / 10
      </label>
      <mat-slider min="1" max="10" step="1" discrete class="w-full">
        <input matSliderThumb formControlName="score" />
      </mat-slider>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button (click)="cancel()">{{ 'waters.form.cancel' | translate }}</button>
  <button mat-flat-button color="primary" [disabled]="form.invalid" (click)="save()">
    {{ 'waters.form.save' | translate }}
  </button>
</mat-dialog-actions>
